<template>
  <div :class="['feedbacks', getSentimentClass(feedback.sentiment_score)]">
    <div class="feedback-left">
      <div class="feedback-text" v-html="formattedFeedback"></div>
      <div class="feedback-date">
        <div
          v-for="cat in feedback.categories"
          :key="cat.id"
          class="categories"
        >
          {{ cat.name }}
        </div>
        <br />
        <div v-if="feedback.unique_identifier">
          Unique Feedback ID {{ feedback.unique_identifier }}
        </div>
        <div v-if="feedback.product_identifier">
          Product ID {{ feedback.product_identifier }}
        </div>
        <div v-if="feedback.product_name">
          Product Name {{ feedback.product_name }}
        </div>
        <div v-if="feedback.product_category">
          Product Category {{ feedback.product_category }}
        </div>
        <div v-if="feedback.device">User Device: {{ feedback.device }}</div>
        <div v-if="feedback.browser">Browser: {{ feedback.browser }}</div>
        <div v-if="feedback.os_name">User OS: {{ feedback.os_name }}</div>
        <div v-if="feedback.page_url">
          Page URL:
          <a :href="feedback.page_url" target="_blank">{{
            feedback.page_url.substring(0, 30) + "..."
          }}</a>
        </div>
        <br />
        <div>
          {{ feedback.created_date }}
        </div>
      </div>
    </div>
    <div class="feedback-right">
      <div class="feedback-rating">
        <div class="sentiment-icons">
          <b>Customer</b><br /><b>Rating</b><br />
          <span v-if="feedback.feedback_rating === null"
            >Not<br />Provided</span
          >
          <span v-else-if="feedback.referral_rating >= 9"
            ><img src="../assets/happy.png"
          /></span>
          <span v-else-if="feedback.referral_rating >= 7"
            ><img src="../assets/neutral.png"
          /></span>
          <span v-else-if="feedback.referral_rating >= -1"
            ><img src="../assets/mad.png"
          /></span>
          <span v-else>Not<br />Provided</span>
        </div>
        <div class="sentiment-icons">
          <b>Referral</b><br /><b>Rating</b><br />
          <span v-if="feedback.referral_rating === null"
            >Not<br />Provided</span
          >
          <span v-else-if="feedback.referral_rating >= 9"
            ><img src="../assets/happy.png"
          /></span>
          <span v-else-if="feedback.referral_rating >= 7"
            ><img src="../assets/neutral.png"
          /></span>
          <span v-else-if="feedback.referral_rating >= -1"
            ><img src="../assets/mad.png"
          /></span>
          <span v-else>Not<br />Provided</span>
          <br />
        </div>
        <div class="sentiment-icons">
          <b>Experience</b><br /><b>Score</b> <br />
          <span v-if="feedback.sentiment_score == 10"
            ><img src="../assets/happy.png"
          /></span>
          <span v-else-if="feedback.sentiment_score == 5"
            ><img src="../assets/neutral.png"
          /></span>
          <span v-else-if="feedback.sentiment_score <= 1"
            ><img src="../assets/mad.png"
          /></span>
          <span v-else>Not<br />Provided</span>
          <br />
        </div>
      </div>
      <!-- <a
        href="#"
        @click.prevent="deleteFeedbackAlert(feedback.id)">Delete</a><br>
      <a
        href="#"
        @click.prevent="deleteFeedbackIsSpamAlert(feedback.id)">Spam</a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackItem",
  props: {
    feedback: {
      default() {
        return {};
      },
      type: Object
    },
    propertyId: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      searchKeywords: ""
    };
  },
  computed: {
    property() {
      return this.$store.getters.property;
    },
    formattedFeedback() {
      return this.feedback.feedback.replace(/\n/g, '<br />');
    }
  },
  methods: {
    search: function() {
      let searchKeywords = this.searchKeywords
        .replace(/\s+/g, "+")
        .toLowerCase();
      this.$router.push({
        name: "dashboardFeedbackSearch",
        query: {
          propertyID: this.propertyId,
          searchKeywords: searchKeywords,
          page: 1,
          categoryId: this.categoryId
        }
      });
    },
    getSentimentClass(score) {
      var sentimentColor = "";
      if (score == 10) {
        sentimentColor = "positive-color-border";
      } else if (score == 5) {
        sentimentColor = "neutral-color-border";
      } else if (score == 1) {
        sentimentColor = "negative-color-border";
      } else {
        sentimentColor = "empty-color-border";
      }
      return sentimentColor;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.feedbacks {
  padding: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #cfe1f6;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
.positive-color-border {
  border-color: #33a878;
  border-width: 2px;
}
.negative-color-border {
  border-color: #df6358;
  border-width: 2px;
}
.neutral-color-border {
  border-color: #e7e5e0;
}
.empty-color-border {
  border-color: #e4e3e1;
}
.feedback-left {
  width: 70%;
  min-height: 280px;
  padding: 10px;
  font-size: 22px;
  float: left;
  position: relative;
  lost-utility: clearfix;
}
.feedback-right {
  width: 100px;
  padding: 15px 0 15px 0;
  float: right;
  background-color: #ecebeb;
  border-radius: 4px;
  border: 1px solid #cfe1f6;
}
.feedback-rating {
  margin: 0 auto;
  width: 100px;
  text-align: center;
}
.sentiment-icons {
  text-align: center;
  display: block;
}
.sentiment-icons img {
  width: 30px;
  padding-top: 5px;
}
.feedback-text {
  display: block;
}
b {
  font-weight: bold;
}
.feedback-date {
  margin-top: 20px;
  float: left;
  width: 100%;
  font-size: 16px;
}
.categories {
  display: block;
}
.feedbacks b {
  font-weight: bold;
}
/* Clear floats after the columns */
.feedbacks:after {
  content: "";
  display: table;
  clear: both;
}

@media (max-width: 760px) {
  .feedback-rating {
    width: 100%;
  }
  .feedback-date {
    width: 100%;
  }
}
</style>
